import React from 'react'
import { RouteHandler } from 'react-router'
import DocumentTitle from 'react-document-title'
import TopNav from './components/topNav'
import BottomNav from './components/bottomNav'
import Notify from './components/notify'
import { Grid } from 'react-bootstrap'

/**
 * Main app component
 */
class App extends React.Component {
  static propTypes = {
    store: React.PropTypes.object.isRequired,
    account: React.PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: React.PropTypes.func
  }

  static childContextTypes = {
    store: React.PropTypes.object,
    notify: React.PropTypes.func
  }

  static fetchData (store, params) {
    return {
      account: store.get('/account')
    }
  }

  state = { message: null }

  getChildContext() {
    return {
      notify: ::this.notify,
      store: this.props.store
    }
  }

  componentWillReceiveProps (props) {
    this.setState({ message: null })
  }

  notify (message) {
    this.refs.notify.send(message)
  }

  render() {
    const { account, store } = this.props
    const { router } = this.context
    const path = router.getCurrentPath()

    const lastResult = !/(results|search)/.test(path) && store.storage.lastSearchResult
    const isMap = /map/.test(path)

    const isDelinq = account.getIn(['group', 'isDelinq'])
    if (isDelinq && !/(dashboard|account)/.test(path)) {
      router.goBack()
    }

    return (
      // Default title
      <DocumentTitle title="REDIComps">
        <div>
          <TopNav account={account} lastResult={lastResult} isMap={isMap} path={path} />
          <Grid fluid>
            <RouteHandler {...this.props} />
          </Grid>
          <BottomNav account={account} path={path} />
          <Notify ref="notify" />
        </div>
      </DocumentTitle>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./modules/shared/app.js